import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export function DashboardRouter() {
    /*Rotas para Historico de Atividades*/
    const DashboardAdministrative = lazy(() => import('../../pages/dashboard/DashboardAdministrative'))
    const DashboardFinance = lazy(() => import('../../pages/dashboard/DashboardFinance'))

    return (
        <Switch>
            {/*Rotas para Historico de Atividades*/}
            <Route path='/painel/administrativo' component={DashboardAdministrative} />
            <Route path='/painel/financeiro' component={DashboardFinance} />
        </Switch>
    )
}
